import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 用户信息
    userInfo: null,
    // 是否已登录
    isLogin: false,
    // 全局加载状态
    loading: false
  },
  getters: {
    // 获取用户信息
    getUserInfo: state => state.userInfo,
    // 获取登录状态
    getLoginStatus: state => state.isLogin,
    // 获取加载状态
    getLoadingStatus: state => state.loading
  },
  mutations: {
    // 设置用户信息
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    // 设置登录状态
    SET_LOGIN_STATUS(state, status) {
      state.isLogin = status
    },
    // 设置加载状态
    SET_LOADING_STATUS(state, status) {
      state.loading = status
    }
  },
  actions: {
    // 更新用户信息
    updateUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    },
    // 更新登录状态
    updateLoginStatus({ commit }, status) {
      commit('SET_LOGIN_STATUS', status)
    },
    // 更新加载状态
    updateLoadingStatus({ commit }, status) {
      commit('SET_LOADING_STATUS', status)
    }
  },
  modules: {
  }
})